import { checkIsNotNullish } from "@tsp-core/utils/nullish";
import { parseUnknownToString } from "@tsp-core/utils/string";

import { WorkSubTypeUuid, WorkSubTypesDictionaryRecord } from "../types";

export function parseWorkSubTypeUuid<Input extends unknown>(
  input: Input,
): Input extends WorkSubTypeUuid ? WorkSubTypeUuid : WorkSubTypeUuid | null {
  const id = parseUnknownToString(input);
  if (checkIsNotNullish(id)) {
    return id as WorkSubTypeUuid;
  }

  return null as any;
}

export function checkWorkSubTypeIsActive(record: WorkSubTypesDictionaryRecord): boolean {
  return !record.isDeprecated;
}
